import classNames from 'classnames';
import styles from './styles.module.css';
import { CarAllocation } from '../../../types/carAllocation';
import { mustGetWorkCateoryIDByName } from '../../../services/workCategory';

const workCategoryColor: Record<number, string> = {
  [mustGetWorkCateoryIDByName('回収')]: styles.blue,
  [mustGetWorkCateoryIDByName('処分')]: styles.yellow,
  [mustGetWorkCateoryIDByName('積込')]: styles.lightYellow,
  [mustGetWorkCateoryIDByName('保管')]: styles.lightBlue,
};

type Props = {
  value: CarAllocation['workCategory'];
};

function WorkCategoryTag({ value }: Props) {
  const color =
    workCategoryColor[value.id] ??
    /* 既知のカテゴリ以外の場合のフォールバック */ styles.other;
  return (
    <span className={classNames(styles.workCategory, color)}>{value.name}</span>
  );
}

export default WorkCategoryTag;
